<template>
  <div class="yzm-textfoldbutton">yzm-textfoldbutton</div>
</template>
<script setup></script>
<style lang="less" scoped>
.yzm-textfoldbutton {
}
</style>